import {
  TypeOfMetrics,
  getAllTemplates,
  addTemplate,
  changeTemplate,
  disableTemplate,
  slowTraces,
  MetaData,
  SampleRecords,
  AllSampleRecords,
  getCapabilityCorrelation,
  getActiveInstancesCount,
  downloadAllRecords,
  getProfiles,
  getSocketIO,
  getGarbageCollectionData,
  getHeapAndMetaSummaryData,
  getTlabAllocationData,
  getGCConfig,
  getMethodProfile,
  getInstanceMemory,
  getStackTraceByThread,
  getThreadInfoByInstanceId,
  getMetaInfoByGCId,
  getTlabSummary,
  getTlabGraphData,
} from '../fragments/dashboard';

export const queryTypeOfMetrics = `query queryTypeOfMetrics(${TypeOfMetrics.variable}) {${TypeOfMetrics.query}}`;

export const mutationAddTemplate = `mutation mutationAddTemplate(${addTemplate.variable}) {${addTemplate.query}}`;

export const mutationChangeTemplate = `mutation mutationChangeTemplate(${changeTemplate.variable}) {${changeTemplate.query}}`;

export const mutationDisableTemplate = `mutation mutationDisableTemplate(${disableTemplate.variable}) {${disableTemplate.query}}`;

export const queryGetAllTemplates = `query queryGetAllTemplates {${getAllTemplates.query}}`;

export const querySlowTraces = `query querySlowTraces(${slowTraces.variable}) {${slowTraces.query}}`;

export const queryMetaData = `query readAggregatedScopedMetrics(${MetaData.variable}) {${MetaData.query}}`;

export const querySampleRecords = `query readAggregatedScopedMetrics(${SampleRecords.variable}) {${SampleRecords.query}}`;

export const queryAllSampleRecords = `query readAllSampledRecords(${AllSampleRecords.variable}) {${AllSampleRecords.query}}`;

export const queryGetCapabilityCorrelatedOverview = `query getCapabilityCorrelatedOverview(${getCapabilityCorrelation.variable}) {${getCapabilityCorrelation.query}}`;

export const queryGetActiveInstancesCount = `query getActiveInstancesCount(${getActiveInstancesCount.variable}) {${getActiveInstancesCount.query}}`;

export const queryDownloadAllSampleRecords = `query downloadAllSampleRecords(${downloadAllRecords.variable}) {${downloadAllRecords.query}}`;

export const queryGetProfiles = `query findCodeProfile(${getProfiles.variable}) {${getProfiles.query}}`;

export const querySocketIO = `query fetchSocketIO(${getSocketIO.variable}) {${getSocketIO.query}}`;

export const queryGarbageCollectionData = `query fetchGarbageCollectionInfo(${getGarbageCollectionData.variable}) {${getGarbageCollectionData.query}}`;

export const queryHeapAndMetaSummaryData = `query fetchHeapAndMetaSummary(${getHeapAndMetaSummaryData.variable}) {${getHeapAndMetaSummaryData.query}}`;

export const queryTLABAllocationData = `query getTLABAllocationTable(${getTlabAllocationData.variable}) {${getTlabAllocationData.query}}`;
export const queryGCConfig = `query fetchGarbageConfiguration(${getGCConfig.variable}) {${getGCConfig.query}}`;

export const queryMethodProfile = `query fetchMethodProfilingInfo(${getMethodProfile.variable}) {${getMethodProfile.query}}`;

export const queryInstanceMemory = `query getMemoryDataOfClassList(${getInstanceMemory.variable}) {${getInstanceMemory.query}}`;

export const queryStackTraceByThread = `query findStacktraceByThreadId(${getStackTraceByThread.variable}) {${getStackTraceByThread.query}}`;

export const queryThreadByInstanceId = `query fetchThreadInfoByInstanceId(${getThreadInfoByInstanceId.variable}) {${getThreadInfoByInstanceId.query}}`;
export const queryMetaInfoByGcId = `query fetchMetaInfoByGCID(${getMetaInfoByGCId.variable}) {${getMetaInfoByGCId.query}}`;

export const queryTlabSummary = `query getTLABSummary(${getTlabSummary.variable}) {${getTlabSummary.query}}`;

export const queryTlabGraphData = `query getTLABGraph(${getTlabGraphData.variable}) {${getTlabGraphData.query}}`;
